<template>
    <div
        :class="searchActive ? 'search-active' : ''"
        class="search"
    >
        <button
            :aria-expanded="searchActive.toString()"
            aria-controls="search-input"
            title="Search"
            class="search__button"
            @click="toggleSearch()"
        >
            <span
                class="search__button--label"
                v-text="searchActive ? 'Close Search' : 'Open Search'"
            />
            <span class="search__button-icon--wrapper">
                <svg
                    v-show="!searchActive"
                    class="search__button-icon"
                    viewBox="0 0 13.22 13.19"
                >
                    <!-- eslint-disable-next-line vue/html-self-closing -->
                    <use xlink:href="/o/udliferay-theme/images/symbols/search-icon.svg#search-icon"></use>
                </svg>

                <svg
                    v-show="searchActive"
                    class="search__button-icon"
                    viewBox="0 0 12.06 12.06"
                >
                    <!-- eslint-disable-next-line vue/html-self-closing -->
                    <use xlink:href="/o/udliferay-theme/images/symbols/close-icon.svg#close-icon"></use>
                </svg>
            </span>
        </button>
        <form
            :id="id"
            action="/group/porches/search"
            class="search__form"
        >
            <input
                name="cx"
                type="hidden"
                value="005091531186671414747:zv6fhtza838">
            <input
                name="cof"
                type="hidden"
                value="FORID:11">
            <input
                name="ie"
                type="hidden"
                value="UTF-8">
            <label
                :for="inputid"
                class="search__input--label">
                Search
            </label>
            <input
                id="search-input"
                ref="searchInput"
                :disabled="!searchActive"
                :class="searchActive ? 'search-active' : null"
                :id="inputid"
                name="q"
                type="search"
                class="search__input"
                placeholder="Search"
            >
            <button
                type="submit"
                class="search__submit"
                name="sa"
            >
                <span class="search__submit--label">Submit</span>
                <span class="search__submit-icon--wrapper">
                    <svg
                        class="search__submit-icon"
                        viewBox="0 0 13.75 12.16"
                    >
                        <!-- eslint-disable max-len -->
                        <!-- eslint-disable-next-line vue/html-self-closing -->
                        <use xlink:href="/o/udliferay-theme/images/symbols/arrow-icon.svg#arrow-icon"></use>
                        <!-- eslint-enable max-len -->
                    </svg>
                </span>
            </button>
        </form>
    </div>
</template>

<script>

export default {
    name: 'UtilitySearch',
    props: {
        id: {
            type: String,
            required: true,
        },
        inputid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            searchActive: false,
        };
    },
    methods: {
        toggleSearch() {
            this.$emit('toggleSearch');
            this.searchActive = !this.searchActive;

            if (this.searchActive) {
                setTimeout(() => {
                    this.$refs.searchInput.focus();
                }, 250);
            }
        },
    },
};
</script>

<style lang="scss">

.search__button {
    @include reset-button;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
    width: $search-button;
    height: 100%;
    cursor: pointer;

    .search__button-icon {
        @include button-transition(fill);
        top: auto;
        width: 20px;
        fill: $ui-gray;
    }

    &:hover,
    &:focus {
        .search__button-icon {
            fill: $glow-turquoise;
        }
    }
}

.search__submit {
    @include reset-button;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
    width: $search-button;
    height: 100%;
    cursor: pointer;
    background-color: $glow-turquoise;

    .search__submit-icon {
        @include button-transition(fill);
        top: auto;
        width: 20px;
        fill: $glow-blue;
    }

    &:hover,
    &:focus {
        .search__submit-icon {
            fill: $glow-navy;
        }
    }
}

.search__button-icon--wrapper,
.search__submit-icon--wrapper {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
}

.search__input {
    @include base-input;
    @include input-transition(color, border-color);
    width: 100%;
    height: 100%;
    color: $white;
    outline: 0;

    .body_menu-active & {
        color: $copy-black;
    }

    @include breakpoint(large) {
        width: $search-input;
    }
}

.search__form {
    display: flex;
    width: 100%;
    height: calc(100% - #{$thick-border-width});
    align-self: flex-start;

    @include breakpoint(large) {
        height: 100%;
    }
}

.search__button[aria-expanded="true"] + .search__form {
    @include button-transition(transform);

    @include breakpoint(large) {
        @include button-transition(transform);
        width: $search-form;
        transform: translateX(0);
    }
}

.search__button[aria-expanded="false"] + .search__form {

    @include breakpoint(large) {
        @include button-transition(transform);
        transform: translateX($search-input);
    }
}

.search__controls {
    @include button-transition(transform);
    display: flex;
    order: 2;
    align-items: center;
    width: 50%;
    height: 100%;

    &.search-active {
        transform: translate(calc(-100% + #{$search-button}));
    }

    @include breakpoint(large) {
        width: auto;
        transform: translateX($search-form);

        &.search-active {
            transform: translateX(0);
        }
    }
}

.search-active + .utility__list {
    @include button-transition(transform);
    transform: translateX(-100%);

    @include breakpoint(large) {
        transform: translateX(0);
    }
}

.search__input--label,
.search__button--label,
.search__submit--label {
    @include access-hidden;
}

/* clears the ‘X’ from Internet Explorer */
#search-input-small::-ms-clear { display: none; width : 0; height: 0; }
#search-input-small::-ms-reveal { display: none; width : 0; height: 0; }
/* clears the ‘X’ from Chrome */
#search-input-small::-webkit-search-decoration,
#search-input-small::-webkit-search-cancel-button,
#search-input-small::-webkit-search-results-button,
#search-input-small::-webkit-search-results-decoration { display: none; }
</style>



// WEBPACK FOOTER //
// src/components/UtilitySearchPorches.vue